import React from 'react'

import ScreenViewEventWrapper from '@zet/common/components/screenViewEventWrapper'
import BrandListV2 from '@zet/feature-brands/screens/brandListV2'

const ProductList = () => {
  return (
    <ScreenViewEventWrapper screenName="brands_list_new_web_flow_recommendation">
      {/* <BrandRecommendationList /> */}
      <BrandListV2 />
    </ScreenViewEventWrapper>
  )
}

export default ProductList
